import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Box, useTheme, Button, useMediaQuery } from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import { tokens } from "../../theme";
import Header from "../../components/Header";
import axios from "axios";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import config from "../../config";
import { getAuthToken } from "../../utils/authStorage";
import { jwtDecode } from "jwt-decode";

const SubscriptionList = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const colors = tokens(theme.palette.mode);
  const [selectedRow, setSelectedRow] = useState(null);
  const navigate = useNavigate();
  const [subscriptionList, setSubscriptionList] = useState([]);
  const token = getAuthToken();
  let role = null;
  try {
    role = token ? jwtDecode(token)?.role : null;
  } catch (error) {
    role = null;
  }
  const canManage = role === "global_admin";

  useEffect(() => {
    const fetchSubscriptions = async () => {
      try {
        const response = await axios.get(`${config.apiBaseUrl}/get_subscriptions`);
        console.log(response.data);
        setSubscriptionList(response.data["subscriptions"]);
        console.log(subscriptionList);
      } catch (error) {
        console.error("Failed to fetch subscriptions:", error);
        toast.error("Failed to fetch subscriptions");
      }
    };

    fetchSubscriptions();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps


  const columns = [
    {
      field: "subscription_name",
      headerName: "Subscription Name",
      flex: 1,
      minWidth: 190,
      cellClassName: "name-column--cell",
    },
    {
      field: "subscription_price",
      headerName: "Price",
      flex: 0.5,
      minWidth: 110,
    },
    {
      field: "subscription_type",
      headerName: "Type",
      flex: 0.5,
      minWidth: 110,
      renderCell: ({ row }) => {
        const typeMap = { day: "Day", monthly: "Monthly", annual: "Annual" };
        return typeMap[row.subscription_type] || row.subscription_type || "-";
      },
    },
    {
      field: "subscription_session",
      headerName: "Session",
      flex: 0.5,
      minWidth: 120,
      renderCell: ({ row }) => (row.subscription_session !== null && row.subscription_session !== undefined ? row.subscription_session : "-"),
    },
    {
      field: "subscription_desc",
      headerName: "Description",
      flex: 1,
      minWidth: 230,
      renderCell: ({ row }) => row.subscription_desc || "-",
    },
  ];

  const handleSelectionChange = (newSelection) => {
    setSelectedRow(newSelection.length === 1 ? newSelection[0] : null);
    console.log(selectedRow);
  };

  const handleUpdate = () => {
    if (selectedRow) {
      console.log("Selected Row ", selectedRow);
      const selectSubscription = subscriptionList.find((subscription) => subscription.subscription_id === selectedRow);
      console.log(selectSubscription);
      navigate("/manage_subscription", { state: { subscription: selectSubscription } });
    }
  }

  const handleDelete = async () => {
    if (selectedRow) {
      console.log("Selected Row ", selectedRow);
      const selectSubscription = subscriptionList.find((subscription) => subscription.subscription_id === selectedRow);
      console.log(selectSubscription);
      try {
        await axios.delete(`${config.apiBaseUrl}/delete_subscription/${selectedRow}`, {
          headers: {
            Authorization: `Bearer ${document.cookie
              .split("; ")
              .find((row) => row.startsWith("teba_auth_token="))
              ?.split("=")[1]}`,
          },
        });
        toast.success("Subscription deleted successfully");
        setSubscriptionList(subscriptionList.filter((subscription) => subscription.subscription_id !== selectedRow));
        setSelectedRow(null);
      } catch (error) {
        console.error("Failed to delete subscription:", error);
        toast.error("Failed to delete subscription");
      }
    }
  }

  return (
    <Box m={{ xs: "12px", sm: "16px", md: "20px" }}>
      <ToastContainer />
      <Header title="Subscription List" subtitle="Subscription List" />
      {selectedRow && canManage && (
        <Box display="flex" justifyContent="flex-start" flexWrap="wrap" gap={1} mt={2}>
          <Button variant="contained" color="success" sx={{ mr: { xs: 0, sm: "10px" } }} onClick={handleUpdate} size={isMobile ? "small" : "medium"}>
            Update
          </Button>
          <Button variant="contained" color="error" sx={{ mr: { xs: 0, sm: "10px" } }} onClick={handleDelete} size={isMobile ? "small" : "medium"}>
            Delete
          </Button>
        </Box>
      )}
      <Box
        mt={{ xs: 2, sm: 2.5, md: 4 }}
        height={{ xs: "62vh", sm: "68vh", md: "75vh" }}
        minHeight={{ xs: 360, sm: 420, md: 480 }}
        sx={{
          overflowX: "auto",
          "& .MuiDataGrid-root": {
            border: "none",
            minWidth: 980,
          },
          "& .MuiDataGrid-cell": {
            borderBottom: "none",
            fontSize: { xs: "0.76rem", sm: "0.82rem", md: "0.875rem" },
          },
          "& .MuiDataGrid-columnHeaderTitle": {
            fontSize: { xs: "0.72rem", sm: "0.8rem", md: "0.875rem" },
            fontWeight: 700,
          },
          "& .name-column--cell": {
            color: colors.greenAccent[300],
          },
          "& .MuiDataGrid-columnHeaders": {
            backgroundColor: colors.blueAccent[700],
            borderBottom: "none",
          },
          "& .MuiDataGrid-virtualScroller": {
            backgroundColor: colors.primary[400],
          },
          "& .MuiDataGrid-footerContainer": {
            borderTop: "none",
            backgroundColor: colors.blueAccent[700],
          },
          "& .MuiCheckbox-root": {
            color: `${colors.greenAccent[200]} !important`,
          },
        }}
      >
        <DataGrid
          checkboxSelection={canManage}
          rows={Array.isArray(subscriptionList) ? subscriptionList : []}
          columns={columns}
          rowHeight={isMobile ? 46 : 52}
          getRowId={(row) => row.subscription_id}
          onRowSelectionModelChange={handleSelectionChange} />
      </Box>
    </Box>
  );
};

export default SubscriptionList;